const HebaLoader = () => (
  <div className='heba-loading-container'>
    <div className='heba-loading-illustration'>
      <div className='heba-loading-animation'></div>
    </div>
    <div className='heba-loading-text'>
      <h2>Heba is preparing your perfect event experience🪄</h2>
      <p>Please hold on for a moment while we setup everything for you ✨.</p>
    </div>
  </div>
);

export default HebaLoader;
